// This will be a shared enum along with the participant sign up page
export enum PlanType {
    ndiaManaged = "NDIAManaged",
    planManaged = "PlanManaged",
    selfManaged = "SelfManaged",
}
